'use client'
import {
  SidebarContent,
  SidebarContentTrigger,
  SidebarGroup,
  SidebarGroupContent,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import { useAuth } from '@/services/providers/auth-provider'

export function AppSidebarContent() {
  const auth = useAuth()

  return (
    <>
      <SidebarContent>
        <SidebarGroup>
          <div className="my-4 self-center text-center">
            <div className="mt-4 flex flex-col items-center gap-0">
              <h1 className="font-line text-base font-bold">
                @{auth.user?.username}
              </h1>
              <p className="font-line text-base font-normal text-gray-500">
                {auth.user?.name_en} {auth.user?.surname_en}
              </p>
            </div>
          </div>
          <div className="mx-5 mt-8 flex flex-col gap-[12.5px]">
            <SidebarContentTrigger
              contentType="general"
              variant={'nohover'}
              size={'full'}
            >
              <span className="text-base">แก้ไขข้อมูลส่วนตัว</span>
              <span>&gt;</span>
            </SidebarContentTrigger>
            <SidebarSeparator className="m-0 h-[2px] w-full p-0" />
            <SidebarContentTrigger
              contentType="preference"
              variant={'nohover'}
              size={'full'}
            >
              <span className="text-base">ความสนใจ</span>
              <span>&gt;</span>
            </SidebarContentTrigger>
            <SidebarSeparator className="ml-0 w-full" />
            {/* <SidebarContentTrigger
              contentType="notification"
              variant={'nohover'}
              size={'full'}
            >
              Notification Settings
              <span>&gt;</span>
            </SidebarContentTrigger> */}
            {/* <SidebarSeparator className="ml-0 w-full" /> */}
            {/* <SidebarContent>
              <Link href="/contact">
                <span className="text-base">ติดต่อ</span>
              </Link>
            </SidebarContent>
            <SidebarSeparator className="ml-0 w-full" /> */}
            <SidebarGroup>
              <SidebarGroupContent className="mt-2 flex justify-center">
                <button
                  onClick={() => auth.signOut()}
                  className="z-50 flex h-full w-fit cursor-pointer items-center gap-2 rounded-full bg-red-500 px-4 py-2 font-line text-base text-white transition-colors hover:bg-red-600"
                >
                  ออกจากระบบ
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-5 w-5"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" x2="9" y1="12" y2="12" />
                  </svg>
                </button>
              </SidebarGroupContent>
            </SidebarGroup>
          </div>
        </SidebarGroup>
      </SidebarContent>
    </>
  )
}
